// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selected: null,
  states: []  
}

const inventory_projects = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
    case 'GET_INVENTORY_PROJECTS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'DELETE_INVENTORY_PROJECT':
      return { ...state }
    case 'GET_INVENTORY_PROJECT':
      return { ...state, selected: action.selected }
    case 'GET_STATES':
      return { ...state, states: action.states }
    case 'EDIT_INVENTORY_PROJECTS':
      return { ...state }
    default:
      return { ...state }
  }
}
export default inventory_projects
